import { createContext, useContext } from 'react';

const SiteConfigContext = createContext(null);

export const useSiteConfigContext = () => useContext(SiteConfigContext);

export default SiteConfigContext;
